var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
import { awardingOrganisationsService } from "./../index";
import { paramsToSearchString } from "../../utils/urlHelper";
export class QualificationReferencesServiceSearch extends BaseRemoteService {
    getAll(params = {}) {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (params.filter) {
                const ao = yield awardingOrganisationsService.get(params.filter);
                if (ao) {
                    params.filter = `organisationacronym eq '${ao.acronym}'`;
                }
            }
            else {
                params.filter = "";
            }
            const url = `${this.apiRoot}/qualifications${paramsToSearchString(params)}`;
            const response = yield _super.getRequest.call(this, url);
            response.data = response.data.map(item => ({
                id: item.key,
                name: item.title,
                type: item.type,
                ssa: item.ssa,
            }));
            return response;
        });
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("Not implemented");
        });
    }
}
